import styled from "styled-components";

const THeadTr = styled.tr `
  height: 50px;
`;

export default THeadTr;
